export enum PriceGroupEnum {
  OFFER = 'offer',
  DEVICES_AND_ACCESSORIES = 'devicesAndAccessories',
  ACTIVATION_FEE = 'activationFee',
  TOTAL_PRICE = 'totalPrice',
}

